import { keys } from './keys';

export const defaultData = {
  [keys.SHOWROOM_FLAT_VIEW]: 'number'
};
